import {ApiClient} from '@hconnect/apiclient'

import {QuestionAnswer, RequestFunc} from '../../types'

import {loggingDecorator} from './decorators'

const putAnswerImpl: RequestFunc<QuestionAnswer, QuestionAnswer> = async ({
  plantId,
  questionId,
  answer
}) => {
  await ApiClient.axiosInstance.put<void>(
    `/pom-questionnaires/${plantId}/questions/${questionId}/submissions`,
    {
      answer
    }
  )
  return {plantId, questionId, answer}
}
export const putAnswer = loggingDecorator(putAnswerImpl)
